import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import socket from "../utils/clientSocket";
import {gameState} from "../components/Game";
import Lobby from "../components/Lobby";
import Chat from "../components/Chat";
import CreateGameModal from "../components/CreateGameModal";
import ChessBoard from "../components/ChessBoard";
import {DEFAULT_POSITION} from "chess.js";
import loadRandomPosition, {loadShuffledBoard} from "../clients/GameClient";
import CustomRange from "../components/CustomRange";

const FrontPage = () => {
    const [showCreateModal, setShowCreateModal] = useState(false);
    const navigate = useNavigate();

    const [orientation, setOrientation] = useState("white")
    // For randomization sliders
    const [showRandomizationRules, setShowRandomizationRules] = useState(false);
    const [evalRange, setEvalRange] = useState([-20, 20]);
    const [moveRange, setMoveRange] = useState([1, 100]);
    const [fen, setFen] = useState(DEFAULT_POSITION)

    // Toggle the display of the randomization sliders
    const toggleRandomizationRules = () => {
        setShowRandomizationRules((prev) => !prev);
    };

    const toggleOrientation = () => {
        setOrientation((prev) => (prev === "white" ? "black" : "white"));
    };

    const handleMove = (newFen) => {
        setFen(newFen);
    }

    // Shuffle board function – if randomization is active, pass the ranges
    const shuffleBoard = () => {
        if (showRandomizationRules) {
            const [evalMin, evalMax] = evalRange;
            const [moveMin, moveMax] = moveRange;
            loadRandomPosition(evalMin, evalMax, moveMin, moveMax)
                .then((data) => {
                    if (data && data.fen) setFen(data.fen);
                })
                .catch((error) =>
                    console.error("Error randomizing board:", error)
                );
        } else {
            loadShuffledBoard()
                .then((data) => {
                    if (data && data.fen) setFen(data.fen);
                })
                .catch((error) =>
                    console.error("Error shuffling board:", error)
                );
        }
    };

    useEffect(() => {
        socket.emit("refreshLobby");
    }, [])

    return (
        <div
            style={{
                display: 'flex',
                height: "100vh",
                background: '#f8f8f8'
            }}
        >
            {/* LEFT COLUMN */}
            <div
                style={{
                    width: '17.5rem',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '1rem'
                }}
            >
                <div style={{ marginBottom: '0.1rem' }}>
                    <button
                        className="game-btn"
                        onClick={() => setShowCreateModal(!showCreateModal)}
                    >
                        Create Game
                    </button>
                </div>

                <div
                    style={{
                        boxShadow: '0 0.25rem 0.625rem rgba(0, 0, 0, 0.15)',
                        borderRadius: '0.5rem',
                        backgroundColor: '#fff',
                        height: '15rem',
                        overflowY: 'auto',
                        marginBottom: '1rem',
                        padding: '0.5rem'
                    }}
                >
                    <Lobby />
                </div>

                <div className="box">
                    <Chat style={{height: "12rem"}} chatType={"global"} chatId={"global"}/>
                </div>
                
            </div>

            {/* MAIN AREA (Chessboard) */}
            <main
                style={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    padding: '1rem',
                    marginTop: '3.7rem',
                    marginLeft: '1.7rem'
                }}
            >
                <div style={{ marginLeft: '1rem', display: "flex", flexDirection: "row" }}>
                    <CreateGameModal
                        showCreateModal={showCreateModal}
                        closeModal={() => setShowCreateModal(false)}
                    />
                    <ChessBoard isLiveGame={false} moveCallback={(newFen, newMove) => handleMove(newFen)} orientation={orientation} fen={fen}/>
                    <div className="right-column"
                        style = {{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between"
                        }}

                        >
                        <div className="icon-container-top"
                                style={{ 
                                    display: 'flex', 
                                    flexDirection: 'column', 
                                    alignItems: 'flex-end'
                                 }}
                                >
                            <img
                                src="shuffle_symbol.png"
                                alt="Shuffle Board"
                                className="icon-style icon-margin-bottom"
                                onClick={shuffleBoard}
                            />
                            <img
                                src="randomization_rule_symbol.png"
                                alt="Randomization Rules"
                                className="icon-style icon-margin-bottom"
                                onClick={toggleRandomizationRules}
                            />
                        </div>

                        <div className="icon-container-bottom">
                            <img
                                src="swap_symbol.png"
                                alt="Swap Board Orientation"
                                className="icon-style"
                                onClick={toggleOrientation}
                            />
                        </div>

                    



                        {showRandomizationRules && (
                            <div className="randomization-rules">
                                <CustomRange title={"Eval Range"} min={-5} max={5} onChange={setEvalRange} step={0.5}/>
                                <CustomRange title={"Move Range"} min={0} max={100} onChange={setMoveRange} step={5}/>
                            </div>
                        )}
                    </div>
                </div>
            </main>
        </div>
    );
}

export default FrontPage;
